// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table_header__ThioA {
    background-color: #FFFFFF;
}

.table_title__mH2Mz {
    font-size: large;
    font-weight: 500;
}

.table_title__mH2Mz:first-letter {
    text-transform: uppercase;
}

.table_button__zq1Ur {
    cursor: pointer;
    font-size: medium;
    color: #00A6A8;
    transition: color 0.2s;
    font-weight: 500;
}

.table_button__zq1Ur:hover {
    color: black;
}

/* Table */
.table_table__173Qp {
    width: 100%;
    border-collapse: collapse;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.table_table__173Qp thead th {
    background-color: #f5f6fa;
    color: #333;
    font-weight: 600;
    padding: 12px;
    border-bottom: 1px solid #E5E7EB;
    text-align: left;
}

.table_table__173Qp thead th:first-child {
    text-align: left;
}

.table_table__173Qp thead th:last-child {
    text-align: right;
}

.table_table__173Qp tbody td {
    padding: 12px;
    text-align: left;
    border-bottom: 1px solid #E5E7EB;
    background-color: #FFFFFF;
    color: #6B7280;
}

.table_table__173Qp tbody td:first-child {
    text-align: left;
}

.table_table__173Qp tbody td:last-child {
    text-align: right;
}

.table_table__173Qp tbody tr:last-child td:first-child,
.table_table__173Qp tbody tr:last-child td:last-child {
    border-bottom: none;
}

.table_table__173Qp tbody td:last-child {
    text-align: right;
}

/* Rounded Borders */
.table_table__173Qp thead th:first-child {
    border-top-left-radius: 8px;
}

.table_table__173Qp thead th:last-child {
    border-top-right-radius: 8px;
}

.table_table__173Qp tbody tr:last-child td:first-child {
    border-bottom-left-radius: 8px;
}

.table_table__173Qp tbody tr:last-child td:last-child {
    border-bottom-right-radius: 8px;
}

.table_table__173Qp tbody tr:last-child td {
    border-bottom: none !important;
}

* {
    /*text-decoration: none !important;*/
}

.table_actionButtons__MzIqW {
    display: flex;
    flex-direction: row;
    justify-content: end;
}

.table_actionButtons__MzIqW svg {
    padding-right: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/admin/components/styles/table.module.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA,UAAU;AACV;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,gCAAgC;IAChC,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,oBAAoB;AACpB;IACI,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB","sourcesContent":[".header {\n    background-color: #FFFFFF;\n}\n\n.title {\n    font-size: large;\n    font-weight: 500;\n}\n\n.title:first-letter {\n    text-transform: uppercase;\n}\n\n.button {\n    cursor: pointer;\n    font-size: medium;\n    color: #00A6A8;\n    transition: color 0.2s;\n    font-weight: 500;\n}\n\n.button:hover {\n    color: black;\n}\n\n/* Table */\n.table {\n    width: 100%;\n    border-collapse: collapse;\n    border-radius: 8px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n}\n\n.table thead th {\n    background-color: #f5f6fa;\n    color: #333;\n    font-weight: 600;\n    padding: 12px;\n    border-bottom: 1px solid #E5E7EB;\n    text-align: left;\n}\n\n.table thead th:first-child {\n    text-align: left;\n}\n\n.table thead th:last-child {\n    text-align: right;\n}\n\n.table tbody td {\n    padding: 12px;\n    text-align: left;\n    border-bottom: 1px solid #E5E7EB;\n    background-color: #FFFFFF;\n    color: #6B7280;\n}\n\n.table tbody td:first-child {\n    text-align: left;\n}\n\n.table tbody td:last-child {\n    text-align: right;\n}\n\n.table tbody tr:last-child td:first-child,\n.table tbody tr:last-child td:last-child {\n    border-bottom: none;\n}\n\n.table tbody td:last-child {\n    text-align: right;\n}\n\n/* Rounded Borders */\n.table thead th:first-child {\n    border-top-left-radius: 8px;\n}\n\n.table thead th:last-child {\n    border-top-right-radius: 8px;\n}\n\n.table tbody tr:last-child td:first-child {\n    border-bottom-left-radius: 8px;\n}\n\n.table tbody tr:last-child td:last-child {\n    border-bottom-right-radius: 8px;\n}\n\n.table tbody tr:last-child td {\n    border-bottom: none !important;\n}\n\n* {\n    /*text-decoration: none !important;*/\n}\n\n.actionButtons {\n    display: flex;\n    flex-direction: row;\n    justify-content: end;\n}\n\n.actionButtons svg {\n    padding-right: 0.5rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `table_header__ThioA`,
	"title": `table_title__mH2Mz`,
	"button": `table_button__zq1Ur`,
	"table": `table_table__173Qp`,
	"actionButtons": `table_actionButtons__MzIqW`
};
export default ___CSS_LOADER_EXPORT___;
